import React, { useEffect, useState } from "react";
import { AfterLoginHeader } from "../../../stories/AfterLoginHeader/AfterLoginHeader";
import Fonts from "../../../stories/assets/Fonts";
import Colors from "../../../stories/assets/Colors";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./Notifications.module.css";
import { NotificationFilter } from "../../../stories/NotificationFilter/NotificationFilter";
import { LinkButtonWithIcon } from "../../../stories/LinkButtonWithIcon/LinkButtonWithIcon";
import {
  doubleTickBlueIcon,
  NotificationAnnouncementIcon,
} from "../../../constant/imagePath";
import { PaginationComponent } from "../../../stories/Pagination/Pagination";
import { NotificationBox } from "../../../stories/NotificationBox/NotificationBox";
import { Footer } from "../../../stories/Footer/Footer";
import { SendFeedbackModal } from "../../../components/Modals/CoachFlow/Notifications/SendFeedback/SendFeedback";
import { SuccessFeedbackModal } from "../../../components/Modals/CoachFlow/Notifications/SuccessFeedback/SuccessFeedback";
import { isMobileViewHook } from "../../../CustomHooks/isMobileViewHook";
import NotificationsMobile from "./NotificationsMobile";
import { ReportProblemModal } from "../../../components/Modals/CoachFlow/Notifications/ReportProblem/ReportProblem";
import { ReviewModal } from "../../../components/Modals/CoachFlow/Notifications/Review/Review";
import { useHistory } from "react-router-dom";
import CancelLesson from "../../../components/Modals/CoachFlow/Dashboard/CancelLesson/CancelLesson";

const NotificationDesktop = () => {
  const history = useHistory()
  const [filtercheck, setFiltercheck] = useState([]);
  const [paginatedData, setpaginatedData] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState('')
  const [isShowModalType, setIsShowModalType] = useState('')
  const staticData = [
    {
      title: "Announcement",
      type: "announcement",
      description: "Added new sports and the ability to complain about users.",
      isSeen: true,
      status: "send-feedback",
    },
    {
      title: "Training report",
      description:
        "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
      isSeen: true,
      type: "training-report",
      status: "",
    },
    {
      title: "1-on-1 Tennis Lesson",
      description: "with Ed Collins on Jul 20",
      isSeen: true,
      type: "training-request",
      status: "cancel-lesson",
      date: "July 17,2021",
    },
    {
      title: "Profile onboarding",
      description: "Your onboarding has been approved.",
      isSeen: true,
      type: "profile-update",
      status: "approved",
    },
    {
      title: "Profile onboarding",
      description:
        "Your onboarding has been declined. Since onboarding check wasn’t approved - your account remains private.",
      isSeen: true,
      type: "profile-update",
      status: "declined",
      date: "July 14, 2021",
    },
    {
      title: "Profile banned",
      description:
        "You canceled classes three times less than 24 hours before the start. Unfortunately, we are forced to ban your profile for 2 weeks. After this period, you can use our application as before.",
      isSeen: true,
      type: "profile-update",
      status: "profile-banned",
    },
    {
      title: "Profile unbanned",
      description:
        "Profile unbanned: Congratulations, your profile is active and you can book your lessons again!",
      isSeen: true,
      type: "profile-update",
      status: "profile-unbanned",
    },
    // ,
    // {
    //   title: "lesson-booked",
    //   description:
    //     "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
    //   isSeen: true,
    //   type: "lesson-booked",
    // },
    // {
    //   title: "lesson-cancelled",
    //   description:
    //     "How was your last 1-on-1 Tennis Lesson with Ed Collins on Jul 20,2021?",
    //   isSeen: true,
    //   type: "lesson-cancelled",
    // },
  ];

  const [notificationdata, setNotificationdata] = useState(staticData);
  const filterby = [
    "Announcements",
    "Training reports",
    "Training requests",
    "Profile updates",
    "Lessons booked",
    "Lessons canceled",
    "Payment updates",
  ];

  const onClickSearch = (data) => {
    console.log(data);
  };

  const handleSearch = (data) => {
    console.log(data);
  };

  const [currentPage, setCurrentPage] = useState(1);
  const pagelimit = 6;

  useEffect(() => {
    setpaginatedData(() => {
      const startIndex = currentPage * pagelimit - pagelimit;
      const endIndex = startIndex + pagelimit;
      return notificationdata.slice(startIndex, endIndex);
    });
  }, [currentPage]);

  return (
    <>
      <div
        className={[classes.headerDiv]}
        style={{ borderBottom: `1px solid ${Colors.neutralShadesOfWhisper}` }}
      >
        <AfterLoginHeader
          onClickSearch={onClickSearch}
          showSearch={true}
          onSubmitSearch={handleSearch}
        />
      </div>
      <Container fluid className={[classes.mainContainer]}>
        <Row>
          <Col md={7}>
            <div className={[classes.MiddleHeader].join(" ")}>
              <h3 style={{ ...Fonts.h3, color: Colors.neutralShadesOfNero }}>
                Notifications
              </h3>
              <LinkButtonWithIcon
                text="Mark all as read"
                leftIcon={doubleTickBlueIcon}
                primary={true}
                customStyle={{ ...Fonts.b2, lineHeight: "20px" }}
              />
            </div>

            {paginatedData.map((item, i) => {
              return <NotificationBox data={item}

                onClick1={(type, status) => {
                  setIsShowModalType(type);
                  setIsOpenModal(status);
                  if (status == "go-to-onboarding")
                    history.push("/on-boarding");
                  if (status == "contact-us") history.push("/contact-us");
                  if (status == "chat") history.push("/student-chat");
                }}
                onClick2={(type, status) => {
                  setIsShowModalType(type);
                  setIsOpenModal(status);
                  if (status == "contact-us") history.push("/contact-us");
                }}
              />;
            })}

            {/* All this modals should be displayed inside notificationBox component  */}


            {isShowModalType == "announcement" && (
              <>
                <SendFeedbackModal
                  show={isOpenModal == "send-feedback" && true}
                  setShow={() => setIsOpenModal("")}
                  // to show step count in heading
                  // steps="1 out of 3"
                  title="Tell us about your experience with Kate"
                  detailsLabel="Share your feedback about the lesson"
                />
              </>
            )}
            {isShowModalType == "training-report" && (
              <>
                <ReportProblemModal
                  type="message-from-admin"
                  show={isOpenModal == "report" && true}
                  setShow={() => setIsOpenModal("")}
                />
                <ReviewModal
                  title="Tell us about your experience with John"
                  show={isOpenModal == "leave-review" && true}
                  setShow={() => setIsOpenModal("")}
                />
              </>
            )}

            {isShowModalType == "training-request" && (
              <>
                <CancelLesson
                  show={isOpenModal == "cancel-lesson" && true}
                  setShow={() => setIsOpenModal("")}
                />
              </>
            )}



            {/* <SendFeedbackModal
              show={true}
              title="We would be grateful for your feedback. This way we can get better."
              detailsLabel="Share your feedback about the lesson"
            />
            <SuccessFeedbackModal
              show={true}
              title="Thank you!"
              description="You review was successfully sent."
            />
            <ReportProblemModal show={true} />
            <ReviewModal
              show={true}
              title="Tell us about your experience with John"
            /> */}
            <PaginationComponent
              totalPages={Math.ceil(notificationdata.length / pagelimit)}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          </Col>
          <Col md={5} className={[classes.filterbox].join(" ")}>
            <NotificationFilter
              state={filtercheck}
              setter={setFiltercheck}
              data={filterby}
              isSelectAll={true}
            />
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
};

const Notifications = () => {
  const [isMobile, setIsMobile] = useState(false);
  useEffect(() => {
    isMobileViewHook(setIsMobile, 992);
  }, []);
  return isMobile ? <NotificationsMobile /> : <NotificationDesktop />;
};

export default Notifications;
